import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import './ButtonBack.css';
import { Box, Button, styled } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonReturn = styled(Button)(() => ({
  padding: '6px 25px',
  borderRadius: '20px',
}));

export function ButtonBack() {
  const navigate = useNavigate();

  return (
    <Box className="buttonBack">
      {!isMobile && (
      <ButtonReturn
        variant="outlined"
        onClick={() => {
          navigate('/');
        }}
        className="buttonTextWithIconGoBack"
      >
        <FontAwesomeIcon
          icon="fa-solid fa-arrow-left"
          size="1x"
          color="#1351b4"
          style={{ marginRight: '10px' }}
        />
        Voltar
      </ButtonReturn>
      )}
    </Box>
  );
}
